import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToGallery = () => {
    const element = document.querySelector('#landscape');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black z-10" />
      <div className="absolute inset-0 bg-[#0a0a0a] z-0" />

      {/* Content */}
      <div className="relative z-20 text-center px-4 max-w-4xl mx-auto">
        <div
          className={`transition-all duration-1000 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h1
            className="text-6xl md:text-8xl font-bold mb-6 text-white"
            
          >
            Fabio Matt
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-4">
            Die Welt durch meine Linse
          </p>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto mb-12">
            Hobby-Fotograf mit Leidenschaft für Landschaften, Porträts und Sportfotografie
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToGallery}
              className="px-8 py-4 bg-amber-500 hover:bg-amber-600 text-black font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-amber-500/50"
            >
              Meine Arbeiten ansehen
            </button>
            <button
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-transparent border-2 border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black font-semibold rounded-lg transition-all duration-300 transform hover:scale-105"
            >
              Kontakt aufnehmen
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToGallery}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20 text-amber-400 animate-bounce cursor-pointer hover:text-amber-300 transition-colors"
        aria-label="Scroll down"
      >
        <ChevronDown size={40} />
      </button>
    </section>
  );
};

export default Hero;